import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { infoData, infoData2, shieldType, infoData3 } from "./infoenum";

import { metersToFeet, getFormattedNumber, getWiremapImageUrl } from "../../../../../common/utils";

class QualificationResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wiremap: ""
    };
  }

  lengthUnitConverter = length => {
    const { chartMeasurementUnit } = this.props;
    if (chartMeasurementUnit === "feet") {
      return metersToFeet(length);
    }
    return getFormattedNumber(length);
  };

  render() {
    const {
      classes,
      result,
      subtest,
      subtestWiremapResults,
      translate,
      chartMeasurementUnit
    } = this.props;

    let wiremapImage = getWiremapImageUrl(subtestWiremapResults, chartMeasurementUnit);
    let qualificationResults = subtestWiremapResults ? subtestWiremapResults.qualification : null;
    let expectedSpeed = qualificationResults && qualificationResults.expectedspeed ? qualificationResults.expectedspeed : "-";
    let measuredSpeed = qualificationResults && qualificationResults.measuredspeed ? qualificationResults.measuredspeed : "-";
    let wiremapOnly = expectedSpeed.toLowerCase().startsWith("wiremap");
    return subtestWiremapResults && subtestWiremapResults.subtesttypeid ? (
      <div ref="container">
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={2} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography color="inherit" className={classes.defaultText}>
                {translate("result_test_exec_time")}
              </Typography>
              <Typography color="inherit" className={classes.defaultText}>
                {subtestWiremapResults.teststarted
                  ? moment(subtestWiremapResults.teststarted).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_cable_info")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestWiremapResults.cable}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {chartMeasurementUnit == "feet"
                  ? translate("result_length_2")
                  : translate("result_length_1")}
              </Typography>
              {infoData2.find(o => o.name === subtestWiremapResults.info) ==
              undefined ? (
                <Typography className={classes.defaultText} color="inherit">
                  {this.lengthUnitConverter(subtestWiremapResults.length)}
                </Typography>
              ) : (
                "-"
              )}
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_nvpper")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestWiremapResults.nvp}
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {translate("result_remote_2")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {subtestWiremapResults.remoteid
                  ? subtestWiremapResults.remoteid >= 0
                    ? subtestWiremapResults.remoteid
                    : "-"
                  : "-"}
              </Typography>
            </Grid>
            {wiremapOnly && (
            <Grid item xs={1} className={classes.totalGrid}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {translate("fibre_test_configuration")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                {translate("Wiremap Only")}
              </Typography>
            </Grid>
            )}
            {!wiremapOnly && (
            <Grid item xs={2} className={classes.totalGrid}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <Typography className={classes.defaultText} color="inherit">
                    {translate("speed_type")}
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item xs={6} className={classes.totalGrid}>
                      <Typography className={classes.defaultText} color="inherit">
                        {translate("expected")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.defaultText} color="inherit">
                        {translate("measured")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item xs={6} className={classes.totalGrid}>
                      <Typography className={classes.defaultText} color="inherit">
                        {expectedSpeed}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography className={classes.defaultText} color="inherit">
                        {measuredSpeed}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            )}
            <Grid xs={2} className={classes.totalGrid} style={{ alignItems: 'center'}}>
              <div style={{ height: '18px' }} />
              <Typography className={classes.defaultText} color="inherit">
                {translate("wiremap")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {subtestWiremapResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText} style={{fontSize: "12px"}}>
                      {infoData.find(o => o.name === subtestWiremapResults.info)
                        ? " " +
                          translate(
                            infoData.find(
                              o => o.name === subtestWiremapResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
            <Grid xs={1} className={classes.totalGridLast} style={{ alignItems: 'center'}}>
              <div style={{ height: '18px' }} />
              <Typography
                className={classes.defaultText}
                style={{ marginLeft: "7px" }}
                color="inherit"
              >
                {translate("result_info")}
              </Typography>
              <Typography className={classes.defaultText} color="inherit">
                <React.Fragment className={classes.pass}>
                  <div className={classes.infoHead}>
                    {qualificationResults && qualificationResults.subteststatus.toLowerCase() ==
                    "passed" ? (
                      <Icon className={classes.passState}>check_circle</Icon>
                    ) : (
                      <Icon className={classes.failState}>cancel</Icon>
                    )}
                    <div className={classes.infoText}>
                      {qualificationResults && infoData3.find(o => o.name === qualificationResults.info)
                        ? " " +
                          translate(
                            infoData3.find(
                              o => o.name === qualificationResults.info
                            ).id
                          )
                        : ""}
                    </div>
                  </div>
                </React.Fragment>
              </Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={6}>
              <div className={classes.div_image}>
                {wiremapImage && (
                  <img
                    alt=""
                    src={wiremapImage}
                    className={classes.logo}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.div_image}>
                {qualificationResults && qualificationResults.imageurl && (
                  <img
                    alt=""
                    src={qualificationResults.imageurl}
                    className={classes.speedIndicator}
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={1}>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.div_table1}>
                {infoData2.find(o => o.name === subtestWiremapResults.info) ==
                  undefined && (
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.tableheader_first}>
                          {translate("general_pairs")}
                        </TableCell>
                        <TableCell className={classes.tableheader_first}>
                          {translate("test_length")}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {subtestWiremapResults &&
                      subtestWiremapResults.pindetails &&
                      subtestWiremapResults.pindetails.length
                        ? subtestWiremapResults.pindetails.map((item, k) => {
                            return (
                              <TableRow key={item.id}>
                                <TableCell
                                  className={classes.tablecontent_first}
                                >
                                  {item.pair}
                                </TableCell>
                                <TableCell
                                  className={classes.tablecontent_first}
                                >
                                  {chartMeasurementUnit == "feet"
                                    ? this.lengthUnitConverter(item.length) +
                                      " ft"
                                    : this.lengthUnitConverter(item.length) +
                                      " m"}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        : null}
                    </TableBody>
                  </Table>
                )}
                {/* <Typography color="inherit" className={classes.polarity}>
                  {translate("result_polarity")}
                </Typography>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.tableheader_first}>
                        {translate("result_pins")}
                      </TableCell>
                      <TableCell className={classes.tableheader_first}>
                        {translate("result_voltage")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {subtestWiremapResults &&
                    subtestWiremapResults.voltagedetails &&
                    subtestWiremapResults.voltagedetails.length
                      ? subtestWiremapResults.voltagedetails.map((item, k) => {
                          return (
                            <TableRow key={item.id}>
                              <TableCell className={classes.tablecontent_first}>
                                {translate("pin") + (k + 1)}
                              </TableCell>
                              <TableCell className={classes.tablecontent_first}>
                                {item.voltage}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      : null}
                  </TableBody>
                </Table> */}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    ) : (
      <Typography type="button">{translate("no_data_sg")}</Typography>
    );
  }
  componentWillMount() {
    const { getsubtestWiremapResults, subtest, pager } = this.props;

    getsubtestWiremapResults(pager.jid, pager.tid, subtest, null);
  }
  componentWillReceiveProps(nextProps) {
    const {
      getsubtestWiremapResults,
      subtest,
      pager,
      subtestWiremapResults
    } = nextProps;
    if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
      getsubtestWiremapResults(pager.jid, pager.tid, subtest, null);
    }
    // if (subtestWiremapResults && subtestWiremapResults.wiremap) {
    //   if (this.state.wiremap == "" || this.state.wiremap == undefined) {
    //     this.setState({
    //       wiremap: subtestWiremapResults.wiremap
    //     });
    //   }
    // }
  }
}

export default withStyles(styles)(QualificationResult);



// WEBPACK FOOTER //
// ./src/components/common/results/views/qualification/index.js